import { AllLiveStockFragment, LiveStockQuery } from "@/gql/graphql";
import { gql, useQuery } from "@apollo/client";
import { Select, SelectProps } from "@stenajs-webui/select";
import * as React from "react";
import { useMemo } from "react";

interface Props extends Omit<SelectProps<any>, "value" | "onChange"> {
  value?: string;
  isActive?: boolean;
  onValueChange?: (value: string) => void;
}

const query = gql`
  fragment AllLiveStock on LiveStock {
    id
    code
    description
    id
    presentationOrder
  }
  query LiveStock {
    productPrice {
      liveStock {
        all {
          ...AllLiveStock
        }
      }
    }
  }
`;

interface LiveStockOption {
  label: string;
  value: string;
  data: AllLiveStockFragment;
}

export const LiveStockSelect: React.FC<Props> = ({
  onValueChange,
  isActive,
  value,
  ...selectProps
}) => {
  const { data, loading } = useQuery<LiveStockQuery>(query);

  const livestock = useMemo(() => {
    return data?.productPrice.liveStock.all ?? [];
  }, [data]);

  const options = useMemo(() => {
    const livestockArrayForSort = [...livestock];
    return livestockArrayForSort
      .sort((l) => l.presentationOrder)
      .map((r) => ({
        label: `${r.description}`,
        value: r.id,
        data: r,
      }));
  }, [livestock]);

  const selected = useMemo(
    () => options.filter((o) => o.value === value),
    [options, value]
  );

  return (
    <Select
      isLoading={loading}
      options={options}
      value={selected}
      onChange={(liveStockOption) => {
        const value = (liveStockOption as LiveStockOption | null)?.value;
        if (value !== undefined) {
          onValueChange?.(value);
        }
      }}
      {...selectProps}
    />
  );
};
